import { MeetHttpHelper, NO_DATA_MESSAGE } from '../../../utils/HttpHelper';

const DeleteMeetUploadErrorTankSwimmersData = (meetId, unmatchedMembersArray, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const meetIdForUrl = meetId ? encodeURIComponent(meetId) : 'NaN';
    const url = `/Meet/TimesUpload/UnmatchedPersonsFromError/${meetIdForUrl}`;
    MeetHttpHelper(url, 'DELETE', unmatchedMembersArray)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData: objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteMeetUploadErrorTankSwimmersData;